{
  "panel": {
    "title": "助手",
    "assistantTitle": "助手工作区",
    "subtitle": "提问或描述您的需求。",
    "empty": "暂无消息。",
    "emptyHint": "请告诉助手您正在处理的内容以开始对话。",
    "loading": "正在加载对话……",
    "loadFailed": "无法加载聊天记录。",
    "uploadHint": "上传任务说明后，点击<strong>生成计划</strong>即可开始。输出模板为可选项——计划结构可根据任务说明与领域知识自动推导。",
    "ariaSendMessage": "发送消息",
    "ariaClose": "关闭",
    "feedbackPlaceholder": "描述需要修改或改进的内容……",
    "verticalRequired": "此工作区尚未配置垂直领域。测试工具需要指定垂直领域（例如 liquidity_stress）。",
    "ariaStop": "停止生成"
  },
  "input": {
    "placeholder": "输入消息……",
    "placeholderTestRun": "测试运行进行中……",
    "placeholderProcessing": "正在处理……",
    "placeholderCorpusMutating": "文件处理期间，对话暂停。",
    "placeholderNoPlan": "生成计划后即可开始聊天……",
    "placeholderDataReady": "可以就上传的数据向助手提问……",
    "placeholderPlanFeedback": "对计划提出反馈……",
    "send": "发送",
    "sending": "正在发送……",
    "sendFailed": "消息发送失败。",
    "attach": "附件",
    "stop": "停止",
    "newConversation": "新建对话",
    "uploadTaskFirstTooltip": "请先上传任务说明",
    "planGenInProgressTooltip": "计划生成进行中",
    "micStart": "开始语音输入",
    "micStop": "结束语音输入",
    "micCancel": "取消语音输入",
    "micRequestingPermission": "请允许使用麦克风…",
    "micListening": "正在聆听…",
    "micSpeechDetected": "正在聆听您的消息…",
    "micTranscribing": "正在转写…",
    "micDone": "语音消息已发送",
    "micLevel": "麦克风音量",
    "micUnsupported": "此浏览器不支持语音输入。",
    "placeholderDataReady_auditing": "询问审计证据相关问题…",
    "placeholderPlanFeedback_auditing": "询问审计相关问题或提供反馈…"
  },
  "message": {
    "uploadTaskFirst": "请先上传任务说明以开始。",
    "you": "您",
    "concierge": "助手",
    "thinking": "思考中……",
    "typing": "助手正在输入……",
    "edited": "已编辑",
    "delivered": "已送达",
    "failed": "发送失败",
    "retry": "重试",
    "copy": "复制",
    "copied": "已复制",
    "stopped": "已停止",
    "notStoppable": "此回答已无法停止。",
    "finishedBeforeStop": "此回答在停止之前已完成。",
    "planUpdatedFallback": "已根据您的反馈更新计划。",
    "planUpdatedWithItems_one": "我已更新计划，共 {{count}} 项。",
    "planUpdatedWithItems_other": "我已更新计划，共 {{count}} 项。",
    "planUpdateFailedFallback": "计划更新失败，请重试。"
  },
  "completeness": {
    "freshness": {
      "unknown": "此历史评估未记录证据版本。",
      "superseded": "此评估之后，证据已发生变化。"
    },
    "title": "数据完整性",
    "checking": "正在检查数据……",
    "ready": "可以开始规划",
    "needsMore": "需要更多数据",
    "verdictReady": "您的数据已涵盖所需章节。",
    "verdictNeedsMore": "部分章节仍需补充数据。",
    "verdictPending": "正在评估您的数据……",
    "viewDetails": "查看详情",
    "rerun": "重新检查",
    "rerunning": "重新检查中……",
    "addMoreFiles": "添加更多文件",
    "proceedAnyway": "仍然继续",
    "missingSection": "缺少数据：{{section}}",
    "loadFailed": "无法加载完整性检查结果。",
    "lastChecked": "最近检查时间：{{time}}",
    "dataCoverage": "数据覆盖度",
    "verdicts": {
      "comprehensive": "全面",
      "adequate": "充分",
      "partial": "部分",
      "insufficient": "不足"
    },
    "moreGaps_one": "+{{count}} 项其他缺口",
    "moreGaps_other": "+{{count}} 项其他缺口",
    "moreActions_one": "+{{count}} 项其他操作",
    "moreActions_other": "+{{count}} 项其他操作",
    "moreSuggestions_one": "+{{count}} 条其他建议",
    "moreSuggestions_other": "+{{count}} 条其他建议",
    "anyFormat": "任意格式",
    "recommendedUploads": "建议上传",
    "quickActions": "快捷操作",
    "missingDocuments": "缺少的文档",
    "missingData": "缺少的数据",
    "readyForReport": "可以生成报告",
    "considerMoreData": "建议添加更多数据以改善结果",
    "moreFilesNeeded": "需要更多文件以获得可靠结果"
  },
  "system": {
    "dataCompletenessFailed": "数据完整性检查失败。您仍可继续生成报告，但数据覆盖情况未知。",
    "completenessAssessmentComplete": "数据完整性评估已完成。",
    "dataIngestionComplete": "您的源文件已处理并建立索引，数据可供分析。",
    "planGenerated": "已根据您的任务说明生成包含 {{itemCount}} 个章节的执行计划，请查看下方的计划结构。",
    "planApproved": "计划已批准！您现在可以上传数据源文件以继续生成报告。",
    "generationResumed": "基础设施中断已解除。您可以重新生成各个失败的章节，或通过主生成按钮重新运行剩余章节的生成。",
    "planFeedbackProgress": "正在处理您的计划反馈——修订章节中……"
  },
  "history": {
    "today": "今天",
    "yesterday": "昨天",
    "older": "更早"
  },
  "senderLabel": {
    "you": "你",
    "bennie": "Bennie",
    "bennieDataSearch": "Bennie(数据检索)"
  },
  "statusIndicators": {
    "reconnecting": "连接中断 — 正在确认您的回答是否已完成…",
    "regeneratingSection": "正在重写第 {{sectionId}} 节 — 通常需要几分钟。",
    "regeneratingSectionUnnamed": "正在重写该节 — 通常需要几分钟。",
    "regeneratingElapsed": "已用时 {{minutes}} 分钟",
    "querying": "正在查询知识库…",
    "connecting": "正在串联线索…",
    "crunching": "正在梳理细节…",
    "phrases": [
      "正在思考…",
      "正在处理您的请求…",
      "正在工作…",
      "正在梳理上下文…",
      "正在串联线索…",
      "正在综合信息…",
      "正在组织回答…",
      "正在分析您的输入…",
      "正在构建回答…",
      "正在梳理细节…",
      "正在交叉引用信息源…",
      "正在汇总见解…",
      "正在整理思路…",
      "正在权衡选项…",
      "正在深入分析…",
      "马上就好…",
      "请稍候片刻…",
      "好问题…",
      "正在检索您的文档…",
      "正在查询知识库…",
      "正在提取相关数据…",
      "正在匹配数据需求…",
      "正在评估计划结构…",
      "正在核对监管对齐…",
      "请稍等…",
      "这个挺有意思…",
      "这里需要多方权衡…",
      "正在审视范围影响…",
      "正在梳理文档脉络…",
      "正在扫描源文件…"
    ]
  },
  "refusal": {
    "planAlreadyApproved": {
      "report": "报告计划已获批准并已锁定，无法再更改。",
      "de_checklist": "设计有效性检查清单已获批准并已锁定，无法再更改。",
      "oe_checklist": "运行有效性检查清单已获批准并已锁定，无法再更改。"
    },
    "planRevisionIntegrityFailed": "修订未通过计划完整性检查。您的计划未改变。请说明您希望进行的修改。",
    "planRevisionSavedResponseFailed": "您的修订已保存，但确认失败。请先查看已保存的计划，再请求其他修改。",
    "runItemRegenDisabled": "设计有效性和运行有效性的结果不能逐项重新生成。如需更改，请更新证据后重新运行整个阶段。"
  }
}
